import React, { useState } from 'react';
import { isUndefined } from 'lodash/fp';

import { Icon } from '../icon/Icon';
import { CaretDown, CaretSide } from '../icons';
import styles from './Report.module.scss';
import { InformationTooltip } from '../tooltip';

interface SectionWrapperProps {
    id: string;
    label: string;
    children: JSX.Element;
    description?: string;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ id, label, children, description }) => {
    const [sectionOpen, setSectionOpen] = useState<boolean>(true);
    const sectionOpenIcon = sectionOpen ? CaretDown : CaretSide;

    return (
        <div className={styles.sectionWrapper}>
            <div className={styles.sectionHeader} onClick={() => setSectionOpen(!sectionOpen)}>
                <div className={styles.sectionOpenIcon}>
                    <Icon icon={sectionOpenIcon} fontSize={15} />
                </div>
                <div className={styles.sectionLabel} data-testid={`${id}-section-header`}>{label}</div>
                {!isUndefined(description) && <div className={styles.sectionDescription}><InformationTooltip content={description} /></div>}
            </div>
            {sectionOpen && children}
        </div>
    );
};
